export class SsoMsg {
     public static orgDomainName = 'in.ibm.com';
     public static orgDomain = 'ibm.com';
     public static ResponseMsg = 'Your company does not yet have SSO authorisation set up with Ecosystm. Please use the standard option to sign in';
     public static ErrorMsg = 'Your company does not yet have SSO authorisation set up with Ecosystm. Please use the standard option to create an account'
     public static signInOrgMsg = 'Please Sign in with your organization';
     public static forgetPassMsg = 'Please login with your organization';
     public static SignUpMsg = 'Please Sign Up with your organization';
     public static SignUpOrganization = 'This feature is not available for your organization yet. Please use the regular Sign Up.'
}



// WEBPACK FOOTER //
// ./src/app/util/sso-login-key.ts